import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import styles from './styles';

const useStyles = makeStyles(styles);

interface StyledTypographyProps {
  companySelected: CompanyData | null;
  role?: RolesEnum;
  value: string | number | JSX.Element;
}

const StyledTypography: React.FC<StyledTypographyProps> = ({
  role,
  companySelected,
  value,
}) => {
  const classes = useStyles();

  return (
    <Typography
      className={clsx(classes.valueCard, {
        [classes.valueCardGreen]: inAdminView(role, companySelected),
        [classes.valueCardGray]: inSuperAdminView(role, companySelected),
        [classes.valueCardBlue]: inOperatorView(role, companySelected),
        [classes.valueCardYellow]: companySelected,
      })}
    >
      {value}
    </Typography>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(StyledTypography);
